import { Screen } from '@/components/screen'
import { StatusLine } from '@/features/status-line/status-line'

// Home. Holds the ledger of what agents did once it exists; until then, the
// status line and a note saying the ledger is on its way.
export function Activity() {
  return (
    <Screen title="Activity">
      <StatusLine />
      <p className="max-w-[60ch] text-[13px] text-muted-foreground">
        Everything your agents do will show up here, with a way to undo it. The ledger arrives with a later release.
      </p>
    </Screen>
  )
}
